<template>
  <div class="user-register-box show-flex-box-r">
    <dl class="register-box show-flex-box-c">
      <dt class="show-flex-box-r">
        <span>账号注册</span>
        <strong @click="backToLoginPage">关闭</strong>
      </dt>
      <dd class="register-info">
        <ul class="show-flex-box-c">
          <li><input type="text" placeholder="手机号"  maxlength="11" autocomplete="off" v-model="phoneNumber"></li>
          <li><input type="text" placeholder="昵称" autocomplete="off" v-model='nickName' maxlength="10"></li>
          <li><input type="password" placeholder="密码" autocomplete="off" v-model='regPassword' maxlength="16"></li>
          <li class="register-send-code">
            <sendAuthcode :phoneNum='phoneNumber' :codeType='"reg"' @inputCode='getAuthCode'></sendAuthcode>
          </li>
          <li>
            <span class="save-btn show-flex-box-r" @click="!isLoading && userRegister()">
              <strong>注册</strong>
            </span>
          </li>
        </ul>
      </dd>
      <dd class="go-login show-flex-box-r">
        <strong>已有账号</strong>
        <span @click="backToLoginPage">登录</span>
      </dd>
    </dl>
  </div>
</template>

<script>
import regex from '@/filter/regex'
import sendAuthcode from '@/components/common/send_authcode_cpn'                 //验证码

export default {
  name: 'user_register',
  data () {
    return {
      phoneNumber: '',
      nickName: '',
      regPassword: '',
      isLoading: false,
      authCode: ''
    }
  },
  components: {
    sendAuthcode
  },
  methods: {
    backToLoginPage: function() {
      this.$emit('close-register',false);
    },
    listenkeyEventWithRegister() {
      let vSelf = this;

      $(document).keyup(function() {
        if (vSelf.registerPage && event.keyCode == 13) {
          if (!vSelf.isLoading) {
            vSelf.userRegister();
          }
        }
      })
    },
    // 获取验证码
    getAuthCode: function(code) {
      this.authCode = code;
    },
    userRegister: function() {
      if (regex.isEmpty(this.phoneNumber)) {
        this.$elementMsg.error({
          'message': '手机号不能为空',
          'showClose':true,
          'customClass': 'pop-class-error',
          'duration': 3000
        })
        return;
      } 
      // else if (!regex.isPhoneNumber(this.phoneNumber)) {
      //   this.$elementMsg.error({
      //     'message': '请输入正确手机号',
      //     'showClose':true,
      //     'customClass': 'pop-class-error',
      //     'duration': 3000
      //   })
      //   return;
      // } 
      else if (regex.isEmpty(this.nickName)) {
        this.$elementMsg.error({
          'message': '昵称不能为空',
          'showClose':true,
          'customClass': 'pop-class-error',
          'duration': 3000
        })
        return;
      } else if (!regex.isNickName(this.nickName)) {
        this.$elementMsg.error({
          'message': '请输入正确昵称',
          'showClose':true,
          'customClass': 'pop-class-error',
          'duration': 3000
        })
        return;
      } else if (regex.isEmpty(this.regPassword)) {
        this.$elementMsg.error({
          'message': '密码不能为空',
          'showClose':true,
          'customClass': 'pop-class-error',
          'duration': 3000
        })
        return;
      } else if (!regex.checkStringLength(this.regPassword)) {
        this.$elementMsg.error({
          'message': '请输入不少于6位密码',
          'showClose':true,
          'customClass': 'pop-class-error',
          'duration': 3000
        })
        return;
      } else if (!regex.isUserPassword(this.regPassword)) {
        this.$elementMsg.error({
          'message': '请输入正确密码格式',
          'showClose':true,
          'customClass': 'pop-class-error',
          'duration': 3000
        })
        return;
      } else if (regex.isEmpty(this.authCode)) {
        this.$elementMsg.error({
          'message': '验证码不能为空',
          'showClose':true,
          'customClass': 'pop-class-error',
          'duration': 3000
        })
        return;
      } else if (!regex.isAuthCode(this.authCode)) {
        this.$elementMsg.error({
          'message': '请输入正确验证码',
          'showClose':true,
          'customClass': 'pop-class-error',
          'duration': 3000
        })
        return;
      }

      if (this.isLoading) {
        return;
      }

      let regObj = {
        'phone': this.phoneNumber,
        'nickname': this.nickName,
        'pwd': this.regPassword,
        'vaild': this.authCode
      }

      this.isLoading = true;
      let vSelf = this;

      this.$client.userRegister(regObj)
      .then((res) => {
        if (res.code == '200' || res.code == 200) {
          let curToken = res.data.token;
          vSelf.registerSucceed(curToken);
        }
        this.isLoading = false;
      }).catch((err) => {
        this.isLoading = false;
      })
    },
    registerSucceed: function(curToken) {
      let saveTokenObj = {
        'token': curToken,
        'isAutoLogin': false
      }

      this.$store.commit('SET_TOKEN',saveTokenObj);
      this.$store.commit('LOGIN',true); //登录成功后改变登录状态
      this.registerSuccessThenAutoLogin();
      this.backToLoginPage();
    },
    registerSuccessThenAutoLogin: function() {
      this.$emit('register-success',true);
    },
  },
  watch: {
    registerPage: function() {
      this.listenkeyEventWithRegister();
    }
  }
}
</script>

<style lang="less" scoped>

  //公共字体样式  start
  .user-register-font-style( @size; @weight; @height; @color ) {
    display: block;
    font-size: @size;
    font-weight: @weight;
    line-height: @height;
    color: @color;
    word-break: break-all;
  }

  .user-register-box{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    outline: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.4);
    justify-content: center;
    z-index: 999;
    &>.register-box{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 394px;
      height: 361px;
      padding: 55px 43px 60px 43px;
      background: #fff;
      border-radius: 10px;
      &>dt{
        width: 100%;
        padding-bottom: 40px;
        justify-content: space-between;
        align-items: center;
        &>span{
          .user-register-font-style( 18px; bold; auto; #191D21 );
        }
        &>strong{
          .user-register-font-style( 18px; bold; auto; #191D21 );
          cursor: pointer;
          // background: url('../../assets/common/close_icon.png') no-repeat center center;
          // background-size: 16px 16px;
        }
      }
      &>.register-info{
        width: 100%;
        &>ul{
          width: 100%;
          justify-content: space-between;
          align-items: center;
          &>li{
            width: 100%;
            height: 40px;
            margin-bottom: 20px;
            &>input{
              width: 362px;
              height: 38px;
              padding-left: 14px;
              padding-right: 14px;
              color: #191D21;
              border-radius: 5px;
              height: 38px;
              border: 1px solid #E5E5E5;
              background: #FAFAFA;
              border-radius: 5px;
            }
            &>.save-btn{
              width: 100%;
              height: 40px;
              background: #FF7800;
              border-radius: 5px;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              &>strong{
                .user-register-font-style( 18px; 500; 40px; #fff );
              }
            }
          }
        }
      }
      &>.go-login{
        width: 100%;
        padding-top: 10px;
        justify-content: flex-end;
        align-items: center;
        &>strong{
          .user-register-font-style( 14px; bold; auto; #7F7F7F );
          padding-right: 10px;
        }
        &>span{
          .user-register-font-style( 14px; bold; auto; #FF7800 );
          cursor: pointer;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/register/user_register.vue